import { Autocomplete, Box } from "@mui/material";
import Card from "@mui/material/Card";
import TextField from "@mui/material/TextField";
import React, { useEffect } from "react";
import SalifyFallback from "src/lib/components/salify-fallback/default";
import { H6 } from "src/lib/components/salify-next-layout/default/components/Typography"; // DUMMY CUSTOM DATA
import { useCardSectionContext } from "../../context";

// ==============================================================
const StoreForm = (props: {
  form?: boolean;
  values: any;
  errors: any;
  touched: any;
  handleBlur: any;
  handleChange: any;
  setFieldValue: any;
  controlOnly?: boolean;
  controlPrefix?: string;
  readOnly?: boolean;
}) => {
  const RenderControls = () => {
    const controlPrefix = props.controlPrefix ?? "shipping";
    const { stores, updateFormValue, formValue: _formValue } = useCardSectionContext();
    const [readOnly] = React.useState(!!props.readOnly);
    const formValue = props.values ?? _formValue;
    const [selectedStore, setSelectedStore] = React.useState<any>({
      id: "",
      label: "",
      parentId: null,
      phone: "",
      email: "",
      address: "",
    });
    React.useEffect(() => {
      const storeId = formValue[`${controlPrefix}_store`];
      if (storeId) {
        setSelectedStore(stores.find((store) => store.id === storeId));
      }
    }, [stores]);

    useEffect(() => {
      if (props.values.shipping_store && props.values.shipping_store !== selectedStore.id) {
        setSelectedStore(stores.find((store) => store.id === props.values.shipping_store));
      }
    }, [props.values]);

    const handleChangeStore = (id: string) => {
      props.setFieldValue(`${controlPrefix}_store`, id);
      const store = stores.find((store) => store.id === id);
      setSelectedStore(store);
    };

    return (
      <Box className={"grid grid-cols-1 lg:grid-cols-2 gap-y-4 gap-x-14"}>
        <SalifyFallback.Label
          path="Stores"
          default="Cửa hàng"
          render={(label) => (
            <Autocomplete
              className="col-span-2 lg:col-span-1"
              options={stores ?? []}
              fullWidth
              readOnly={readOnly}
              disableClearable
              getOptionLabel={(option) => option?.label ?? ""}
              value={selectedStore}
              onChange={(_, { id }: any) => handleChangeStore(id)}
              renderInput={(params: any) => (
                <TextField
                  inputProps={{ readOnly }}
                  {...params}
                  {...(props.form
                    ? {
                        error:
                          !!props.touched[`${controlPrefix}_store`] &&
                          !!props.errors[`${controlPrefix}_store`],
                        helperText:
                          props.touched[`${controlPrefix}_store`] &&
                          props.errors[`${controlPrefix}_store`],
                      }
                    : {})}
                  //   InputLabelProps={{ shrink: true }}
                  label={label}
                  size="small"
                />
              )}
            />
          )}
        />
        <SalifyFallback.Label
          path="Address"
          default="Địa chỉ"
          render={(label) => (
            <TextField
              className="col-span-2 lg:col-span-1"
              fullWidth
              onBlur={props.handleBlur}
              label={label}
              onChange={props.handleChange}
              name={"address"}
              InputProps={{ readOnly: true }}
              value={selectedStore?.address ?? ""}
            />
          )}
        />

        <SalifyFallback.Label
          path="Phone Number"
          default="Số điện thoại"
          render={(label) => (
            <TextField
              className="col-span-2 lg:col-span-1"
              fullWidth
              onBlur={props.handleBlur}
              label={label}
              onChange={props.handleChange}
              name={"phone"}
              InputProps={{ readOnly: true }}
              value={selectedStore?.phone ?? ""}
            />
          )}
        />

        <SalifyFallback.Label
          path="Email"
          default="Email"
          render={(label) => (
            <TextField
              className="col-span-2 lg:col-span-1"
              fullWidth
              onBlur={props.handleBlur}
              label={label}
              onChange={props.handleChange}
              name={"email"}
              InputProps={{ readOnly: true }}
              value={selectedStore?.email ?? ""}
            />
          )}
        />
      </Box>
    );
  };

  if (props.controlOnly) return RenderControls();

  return (
    <Card sx={{ mb: 4, p: 3 }}>
      <H6 mb={2}>
        <SalifyFallback.Label path="Shipping Address" default="Kho giao hàng" />
      </H6>

      {RenderControls()}
    </Card>
  );
};

export default StoreForm;
